import { CheckedComponentInformation } from '@west-australian-newspapers/json-react-layouts'
import { Topic } from '@news-mono/web-common'
import { layout } from '../../../../App.routing'
import { getAflCurationSierraComponent } from '../afl-route-component-layouts'

const bannerDesktopX1 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Desktop-Banner-@1x.jpg')
const bannerDesktopX2 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Desktop-Banner-@2x.jpg')
const bannerMobileX1 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Mobile-Banner-@1x.jpg')
const bannerMobileX2 = require<string>('./assets/2025-AFL-Footy-Lives-Here-Mobile-Banner-@2x.jpg')
const socialImage = require('./assets/2025-AFL-Footy-Lives-Here-Social-Image.jpg')

const bannerDesktopX1_2026 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Desktop-@1x.jpg')
const bannerDesktopX2_2026 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Desktop-@2x.jpg')
const bannerMobileX1_2026 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Mobile-@1x.jpg')
const bannerMobileX2_2026 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Mobile-@2x.jpg')
const newSocialImage = require('./assets/2026_WA-Footy-Lives-Here-Social.jpg')

export const getFootyLivesHereSocialImageMeta = (
    topic: Topic,
    use2025Image: boolean,
) => [
    {
        property: 'og:image',
        content: use2025Image ? socialImage : newSocialImage,
    },
    {
        property: 'og:image:width',
        content: '1920',
    },
    {
        property: 'og:image:height',
        content: '1080',
    },
    {
        name: 'twitter:image',
        content: use2025Image ? socialImage : newSocialImage,
    },
    {
        property: 'og:description',
        content: topic.seoDescription ?? `The Latest in ${topic.title}`,
    },
    {
        property: 'twitter:description',
        content: topic.seoDescription ?? `The Latest in ${topic.title}`,
    },
]

export const getFootyLivesHereHeader = (
    topic: Topic,
    use2025Images: boolean,
): CheckedComponentInformation[] => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: use2025Images
                    ? bannerDesktopX2
                    : bannerDesktopX2_2026,
                verticalGutters: ['unset', 'md'],
                altText: topic.seoTitle,
                disableHeader: true,
                sources: [
                    {
                        breakpoint: 'sm',
                        src: [
                            {
                                src: use2025Images
                                    ? bannerDesktopX1
                                    : bannerDesktopX1_2026,
                                density: '1x',
                            },
                            {
                                src: use2025Images
                                    ? bannerDesktopX2
                                    : bannerDesktopX2_2026,
                                density: '2x',
                            },
                        ],
                    },
                    {
                        src: [
                            {
                                src: use2025Images
                                    ? bannerMobileX1
                                    : bannerMobileX1_2026,
                                density: '1x',
                            },
                            {
                                src: use2025Images
                                    ? bannerMobileX2
                                    : bannerMobileX2_2026,
                                density: '2x',
                            },
                        ],
                    },
                ],
            },
        }),
        layout.nestedComposition({
            type: 'janus',
            props: {
                layoutRatio: '3:1',
                stretchColumns: true,
                verticalSpacing: 'xl',
            },
            contentAreas: {
                left: [getAflCurationSierraComponent()],
                right: [
                    layout.component({
                        type: 'footy-lives-here-promo-card',
                        props: {
                            use2025Images,
                        },
                    }),
                ],
            },
        }),
    ]
}
